import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
	transform(value: string, max: number = 10): string {
		let result = value.split(' ').splice(0, max).join(' ');
		if (result.length < value.length) {
			result += '...';
		}
		return result;
	}
}
